import { useCreateManualFormModal } from '~/components/Modals/ManualFormModal';
import { useAppNavigation } from '~/hooks/nav.hook';
import { translate } from '~/utils/translation.utils';

export const useVoucherByAdminReferenceModal = () => {
  const navigation = useAppNavigation();
  return useCreateManualFormModal({
    title: translate('voucher.voucherAdminRef'),
    subtitle: translate('voucher.enterAdminReference'),
    formData: [
      {
        items: [
          {
            type: 'text',
            label: translate('voucher.adminReference'),
            id: 'adminReference',
          },
        ],
      },
    ],
    onConfirm: (value) => {
      navigation.navigate('VouchersByAdminRef', {
        voucherAdminRef: value.adminReference,
      });
    },
  });
};
